import validation from './rules'

/*
greaterThan: (x) => (value) => value > x,
greaterThanEqual: (x) => (value) => value >= x,
lessThan: (x) => (value) => value < x,
lessThanEqual: (x) => (value) => value <= x,
rangeInclusive: (x, y) => (value) => value >= x && value <= y,
*/

function testGreaterThan(x, value, to){
    it("correctly validates greaterThan " + value + " to " + to, () =>{
        const result = validation.greaterThan(x)(value)
        expect(result).toEqual(to)
    })
}

testGreaterThan(10, 11, true);



////////////////////////////////////////////
//
//  errors
//
/////////////////////////////////////////////

it("it validates", () => {
    const fields = {
        firstName:"Jack",
        surname:1234
    }
    const rules = {
        firstName:[
            validation.enforce.name("It must be a name")
        ],
        surname:[
            validation.enforce.name("It must be a name")
        ]
    }
    const messages = validation.validate(fields, rules);
    expect(messages.firstName).toBeUndefined();
    expect(messages.surname).toEqual(["It must be a name"])
})



////////////////////////////////////////////
//
//  enforce
//
/////////////////////////////////////////////

it("it correctly supplies the message when enforcement fails", () =>{
    const message = validation.enforce.number("It is not a number")("asdf");
    expect(message).toEqual("It is not a number");
})


it("it correctly supplies null when enforcement succeeds", () =>{
    const message = validation.enforce.number("It is not a number")(23);
    expect(message).toEqual(null);
})



////////////////////////////////////////////
//
//  required
//
/////////////////////////////////////////////
function testRequired(value, to){
    it("correctly validates required " + value + " to " + to, () =>{
        const result = validation.required(value)
        expect(result).toEqual(to)
    })
}


testRequired("asdf", true);
testRequired("0", true);
testRequired("1", true);
testRequired(1, true);
testRequired(0, true);
testRequired([1], true);
testRequired(false, true);
testRequired(true, true);
testRequired("", false);
testRequired(null, false);
testRequired(undefined, false);
testRequired([], false);



////////////////////////////////////////////
//
//  name
//
/////////////////////////////////////////////

function testName(value, to){
    it("correctly validates name " + value + " to " + to, () =>{
        const result = validation.name(value)
        expect(result).toEqual(to);
    })
}


testName("Mathias d\'Arras", true);
testName("Martin Luther King, Jr.", true);
testName("Hector Sausage-Hausen", true);
testName("Joe3", false)
testName("3Joe", false)
testName("Joe3jo", false)
testName("Joe?", false)
testName(1, false)
testName(0, false)
testName("", false); //!!!!



////////////////////////////////////////////
//
//  numberDecimal
//
/////////////////////////////////////////////

function testNumberDecimal(value, to){
    it("correctly validates numberDecimal " + value + " to " + to, () =>{
        const result = validation.numberDecimal(value)
        expect(result).toEqual(to);
    })
}

testNumberDecimal(1, true);
testNumberDecimal(1.23, true);
testNumberDecimal(0, true);
testNumberDecimal("something", false);
testNumberDecimal("0", true);
testNumberDecimal("1", true);
testNumberDecimal("1.2", true);
testNumberDecimal(null, false); // !!! 



////////////////////////////////////////////
//
//  number
//
/////////////////////////////////////////////
function testNumber(value, to){
    it("correctly validates number " + value + " to " + to, () =>{
        const result = validation.number(value)
        expect(result).toEqual(to);
    })
}

testNumber(1, true);
testNumber(0, true);
testNumber("", false);
testNumber("something", false);
testNumber("0", true);
testNumber("1", true);
testNumber("1.0", false);
testNumber(1.1, false);
testNumber(1.0, true);




////////////////////////////////////////////
//
//  isTrue
//
/////////////////////////////////////////////

function testIsTrue(value, to){
    it("correctly validates isTrue " + value + " to " + to, () =>{
        const result = validation.isTrue(value)
        expect(result).toEqual(to);
    })
}

testIsTrue(true, true);
testIsTrue(false, false);
testIsTrue(undefined, false);
testIsTrue(0, false);
testIsTrue(1, false);
testIsTrue("0", false);
testIsTrue("1", false);
testIsTrue("blah", false);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/validation/rules.test.ts